module.exports = __webpack_public_path__ + "static/media/settings.724c268e.svg";